/**
 * Per-device "remind me later" state for the Koala+ -> Qiscus acquisition
 * announcement dialog. Stored in localStorage (not vuex) so it survives
 * logout and is independent of the persisted store shape.
 */
export const ANNOUNCEMENT_REMIND_AT_KEY = "kp_qiscus_announcement_remind_at";

/** 00:00:00.000 local time of the day after `from`. */
export function nextLocalMidnight(from: Date): Date {
  const next = new Date(from.getTime());
  next.setHours(0, 0, 0, 0);
  next.setDate(next.getDate() + 1);
  return next;
}

function readRemindAt(): number | null {
  try {
    const raw = localStorage.getItem(ANNOUNCEMENT_REMIND_AT_KEY);
    if (raw === null) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

/** True when the dialog should be shown at `now`. Fails open on bad storage. */
export function shouldShowAnnouncement(now: Date = new Date()): boolean {
  const remindAt = readRemindAt();
  if (remindAt === null) return true;
  return now.getTime() >= remindAt;
}

/** Snooze the dialog until the next local calendar day. */
export function remindAnnouncementLater(now: Date = new Date()): void {
  try {
    localStorage.setItem(
      ANNOUNCEMENT_REMIND_AT_KEY,
      String(nextLocalMidnight(now).getTime())
    );
  } catch {
    // Storage unavailable: dialog will simply show again next load.
  }
}
